var React = require('react');

function LogoSingleGray (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.9579 14.1818C16.6535 14.1818 18.0284 15.5566 18.0284 17.2523C18.0284 18.948 16.6535 20.3228 14.9579 20.3228C13.2621 20.3228 11.8875 18.948 11.8875 17.2523C11.8875 15.5566 13.2621 14.1818 14.9579 14.1818Z","fill":"#51484A","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.77759 24H8.58897L14.9219 7.94512L21.2694 24H25.0661L14.9842 0L4.77759 24Z","fill":"#51484A","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 9.90021C6.89255 3.7157 23.4337 17.7713 32.5635 11.1396C21.5789 21.1481 11.088 6.96823 0 9.90021Z","fill":"#51484A","key":2})]);
}

LogoSingleGray.defaultProps = {"width":"33","height":"24","viewBox":"0 0 33 24","fill":"none"};

module.exports = LogoSingleGray;

LogoSingleGray.default = LogoSingleGray;
